import React, { Component } from 'react';
import styled from 'styled-components';


class OverlayWindow extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    handleClose() {
        if(this.props.onClose) {
            this.props.onClose();
        }
    }
    render() { 
        if(this.props.isOpen) {
            return (
                <div>
                    <div className="hw-overlay-window-backdrop" onClick={() => this.handleClose()}></div>
                    <div className="hw-overlay-window-container">
                        {this.props.children}
                    </div>
                </div>
            );
        } else {
            return (
                <div></div>
            )
        }
    }
}
 
export default OverlayWindow;